import { URLBuilder } from '@termly-web/common'

import Config from 'config'

export const baseURL = `${ Config.DOMAIN }/api`

const users          = setUrl('/users')
const websites       = setUrl('/websites')
const password       = setUrl('/password')
const plans          = setUrl('/plans')
const documents      = setUrl('/documents')
const snippetDocs    = setUrl('/snippets/documents')
const billing        = setUrl('/billing_info')
const paymentProfile = setUrl('/payment_profile')
const transactions   = setUrl('/transactions')
const auth           = setUrl('/auth')
const identities     = setUrl('/identities')
const checkHistory   = setUrl('/check_history')
const styles         = setUrl('/styles')
const reports        = setUrl('/reports')
const cookieConsent  = setUrl('/cookie_consents')
const apiKey         = setUrl('/api_token')
const ipInfo         = setUrl('/ip')

export const healthURL = `${ Config.DOMAIN }/health`

export const userInfo = () => `${ users }/info`
export const website = (id) => `${ websites }/${ id }`
export const emailTokenVerify = (email, token) => `${ password }/token_verification?email=${ email }&reset_password_token=${ token }`
export const plansInfo = () => plans
export const documentInfo = (id) => `${ documents }/${ id }?status=published`
export const documentSnippet = (id) => `${ snippetDocs }/${ id }?status=published`

export const dsarSettings = (id) => `${ websites }/${ id }/dsar_settings`

export const documentDraftPreview = (id) => `${ documents }/${ id }/preview?status=draft`
export const billingInfo = () => billing
export const editChangeCard = () => `${ paymentProfile }/change_card`
export const getInvoice = (page) => `${ transactions }?page=${ page }`
export const getInvoiceDetails = (id) => `${ transactions }/${ id }`
export const getBillingHistory = () => `${ transactions }`

export const migrateDoc = (id) => `${ documents }/${ id }`
export const getDocument = (id) => `${ documents }/${ id }`
export const signInSocial = (social) => `${ auth }/${ social }`
export const signInCreateAccount = (identityId) => `${ identities }/${ identityId }/create_account`
export const signInMigrateAccount = (identityId) => `${ identities }/${ identityId }/link_account`
export const checkWebSnippet = (id) => `${ checkHistory }/website/${ id }`
export const checkWebSnippetV2 = (id) => `${ Config.DOMAIN }/api/v2/check_history/website/${ id }`
export const checkDocSnippet = (id) => `${ checkHistory }/document/${ id }`
export const checkDocSnippetV2 = (id) => `${ Config.DOMAIN }/api/v2/check_history/document/${ id }`
export const createTheme = (id) => `${ websites }/${ id }/themes`
export const updateExistingTheme = (websiteId, styleId) => `${ websites }/${ websiteId }/themes/${ styleId }`
export const websiteCustomerRequests = (id) => `${ website(id) }/customer_requests`
export const universalPPMigrate = (id) => `${ websites }/${ id }/universal_pp_migrate`
export const updateTheme = (style_id, theme_id) => `${ styles }/${ style_id }/consent_themes/${ theme_id }`
export const getReport = (id) => `${ reports }/${ id }`
export const postCookie = (id) => `${ getReport(id) }/cookies`
export const putCookie = (reportId, id) => `${ postCookie(reportId) }/${ id }`
export const getCookie = (reportId, cookieId) => `${ getReport(reportId) }/cookies/${ cookieId }`
export const deleteCookie = (reportId, cookieId) => `${ getReport(reportId) }/cookies/${ cookieId }`
export const downloadCookieConsentLogs = (startDate, endDate, websiteId) => `${ cookieConsent }/download?start_date=${ startDate }&end_date=${ endDate }&website_id=${ websiteId }`
export const publishCookiePolicy = (id) => `${ documents }/${ id }/publish_cookie_policy`
export const apiToken = (id) => `${ apiKey }?id=${ id }`
export const ip = () => ipInfo
export const sendSnippetCode = setUrl('/send_snippet_code')
export const upgradeIntent = () => `${ paymentProfile }/upgrade/intent`

/**
  query parameter for GET bannerCopies:
  language_setting <array>
  personalized_content <bool>
  running_targeted_advertising <bool>
  share_data_to_3rd_party <bool>
*/
export const bannerCopies = (websiteId, queryString) => `${ websites }/${ websiteId }/consent_widget_settings/banner_copies?${ queryString }`
export const consentThemes = (websiteId) => `${ websites }/${ websiteId }/consent_themes`
export const putConsentThemes = (websiteId, themeId) => `${ websites }/${ websiteId }/consent_themes/${ themeId }`

export const couponLookup = (code) => `${ plans }/coupon_codes/${ code }`


export function setUrl(endpoint = '') {
  // This is not an ideal implementation, but it's what we had before, so
  // we'll roll with it (KISS) for now.
  return `${ baseURL }/v1${ endpoint }`
}

export function editDocLink(websiteId, documentId) {
  return URLBuilder.editWebsiteDocumentURL({
    documentId,
    websiteId,
  })
}

export function addDocLink(templateId, websiteId, policyPath) {
  return URLBuilder.newWebsiteDocumentURL({
    websiteId,
  }, {
    policyPath,
    template_id: templateId,
  })
}

export function createPolicy(templateId) {
  return URLBuilder.newDocumentURL(null, {
    template_id: templateId,
  })
}
